import { LoadingDots, Text } from '@loadsmart/loadsmart-ui'

import { RequestStatus } from 'core/domain/Request'

import { type Proposal } from '../domain/Proposal'
import { formatRfpStatusDate } from '../presenters/rfpPresenter'
import { useRfpContext } from './contexts/RfpContext'

export type RfpStatusType = {
  proposal: Proposal
}

export function RfpStatus({ proposal }: RfpStatusType) {
  const {
    state: { lastSavedDate, submitLaneProposalStatus },
  } = useRfpContext()

  if (submitLaneProposalStatus === RequestStatus.Pending) {
    return (
      <>
        <Text variant="caption">Saving...</Text>
        <LoadingDots size={8} />
      </>
    )
  }

  const date = formatRfpStatusDate(proposal.submittedAt ?? lastSavedDate)

  if (!date) return null

  if (proposal.submittedAt) {
    return <Text variant="caption">{`Offer submitted at ${date}`}</Text>
  }

  return <Text variant="caption">{`Last saved at ${date}`}</Text>
}
